import { useState } from "react";
import { Button, Card,Grid, Group, Text,TextInput, Select, MultiSelect, Badge, ActionIcon, NumberInput, Stack } from "@mantine/core";
import { IconPencil, IconTrash, IconX, IconDeviceFloppy } from "@tabler/icons-react";
import { useForm } from "@mantine/form";

export default function CriteriaCardEditor({
  criterion,
  objectivesOptions,
  categoryOptions = [],
  isEditing,
  onEdit,
  onCancel,
  onSave,
  onDelete,
}) {

  const form = useForm({
    initialValues: {
      id: criterion.id ?? null,
      cid: criterion.cid ?? null,
      order: criterion.order ?? 1,
      description: criterion.description ?? "",
      categories: criterion.categories ?? [],
      objectiveId: criterion.objectiveId ?? null,
    },
    validate: {
      order: (v) => {
        const n = parseInt(v, 10);
        return Number.isInteger(n) && n >= 1 ? null : "Debe ser un entero ≥ 1";
      },
      description: (v) => (v?.trim() ? null : "Requerido"),
      objectiveId: (v) => (v ? null : "Requerido"),
    },
  });
  
  const view = (
    <Card withBorder radius="md" p="md">
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Group wrap="nowrap">
          <Text size="xl" fw={700} c={'#e72166'}>{criterion?.order}.</Text>
          <Stack gap={5}>
            <Text fw={600}>{criterion?.description || "Sin nombre"}</Text>
            <Group gap={'xs'}>
              <Badge variant="default">{objectivesOptions.find(o => o.value === criterion?.objectiveId)?.label || "—"}</Badge>
              {(criterion?.categories || []).map((c, index) => (
                <Badge key={index}>{categoryOptions.find(o => o.value === c)?.label || "—"}</Badge>
              ))}
            </Group>
          </Stack>
        </Group>

        <Group gap="xs" wrap="nowrap">
          <ActionIcon variant="light" onClick={() => onEdit(criterion.cid ?? criterion.id)} aria-label="Editar">
            <IconPencil size={16} />
          </ActionIcon>
          <ActionIcon color="red" variant="light" onClick={() => onDelete(criterion.cid ?? criterion.id)} aria-label="Eliminar">
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      </Group>
    </Card>
  );

  const edit = (
    <Card withBorder radius="md" p="md">
      <form onSubmit={form.onSubmit((vals) => onSave(vals))}>
        <Grid gutter="sm">
          <Grid.Col span={{ base: 12, md: 2 }}>
            <NumberInput
              label="Numero"
              placeholder="1,2,3, ..."
              allowNegative={false}
              allowDecimal={false}
              min={1}
              {...form.getInputProps('order')}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 10 }}>
            <TextInput
              label="Nombre"
              placeholder="Ej: Desarrollo de un modelo ... "
              {...form.getInputProps('description')}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <Select
              label="Vincular a Objetivo"
              placeholder="Buscar objetivo..."
              data={objectivesOptions}
              {...form.getInputProps('objectiveId')}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <MultiSelect
              label="Categorías"
              clearable
              data={categoryOptions}
              {...form.getInputProps('categories')}
            />
          </Grid.Col>

          <Grid.Col span={12}>
            <Group justify="flex-end" mt="xs">
              <Button variant="default" leftSection={<IconX size={16} />} onClick={() => onCancel()}>
                Cancelar
              </Button>
              <Button leftSection={<IconDeviceFloppy size={16} />} type="submit">
                Guardar
              </Button>
            </Group>
          </Grid.Col>
        </Grid>
      </form>
    </Card>
  );

  return isEditing ? edit : view;
}